import './App.css';

import React,{useEffect,useRef,useState} from "react";
import {CopyToClipboard} from "react-copy-to-clipboard";
import Peer from "simple-peer";
import io from "socket.io-client";

const socket = io.connect("https://videomy-videocall.herokuapp.com");

function App() {

  const [ me, setMe ] = useState("")
	const [ stream, setStream ] = useState()
	const [ receivingCall, setReceivingCall ] = useState(false)
	const [ caller, setCaller ] = useState("")
	const [ callerSignal, setCallerSignal ] = useState()
	const [ callAccepted, setCallAccepted ] = useState(false)
	const [ idToCall, setIdToCall ] = useState("")
	const [ callEnded, setCallEnded] = useState(false)
	const [ name, setName ] = useState("")

	const myVideo = useRef()
	const userVideo = useRef()
	const connectionRef= useRef()

  useEffect(() => {
    navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true,
    }).then(
      (stream)=>{
        setStream(stream)
        myVideo.current.srcObject = stream;
      }
    )

    socket.on("me", (id) => {
			setMe(id)
		})

    socket.on("callUser", (data) => {
			setReceivingCall(true)
			setCaller(data.from)
			setName(data.name)
			setCallerSignal(data.signal)
		})

  }, [])

  // call user

  const callUser = (id) => {
		const peer = new Peer({
			initiator: true,
			trickle: false,
			stream: stream
		})

		peer.on("signal", (data) => {
			socket.emit("callUser", {
				userToCall: id,
				signalData: data,
				from: me,
				name: name
			})
		})

		peer.on("stream", (stream) => {
				userVideo.current.srcObject = stream;
		})

		socket.on("callAccepted", (signal) => {
			setCallAccepted(true)
			peer.signal(signal)
		})

		connectionRef.current = peer
	}

  const answerCall =() =>  {

		setCallAccepted(true)

		const peer = new Peer({
			initiator: false,
			trickle: false,
			stream: stream
		})

		peer.on("signal", (data) => {
			socket.emit("answerCall", { signal: data, to: caller })
		})

		peer.on("stream", (stream) => {
			userVideo.current.srcObject = stream
		})

		peer.signal(callerSignal)
		connectionRef.current = peer
	}

  const leaveCall = () => {
		setCallEnded(true)
		connectionRef.current.destroy()
	}

  return (
    <div className="App">
      <header>
        <h3>Videomy</h3>
      </header>

      <main>
        {/* video player */}
      <div className="video-container ">
            {/* my video */}
            {
                stream ? (
                    <div className=" videoplayer myVideo">
                    <h4 className="username">{"You"}</h4>
                    <div className="videolayout">
                        <video playsInline muted ref={myVideo} autoPlay className="Videomy" />
                    </div>
                    </div>
                ) : (
                    <h2 className="perm">Allow Device Permissions</h2>
                )
            }
            {/* userVideo */} 
            {
                callAccepted && !callEnded &&(
                    <div className=" videoplayer userVideo">
                    <h4 className="username">{"They"}</h4>
                    <div className="videolayout ">
                        <video playsInline ref={userVideo} autoPlay className="Videouser" />
                    </div>
                    </div>
                )
            }
        </div>

      {/* controls */}
      <div className="option-container">
            <form noValidate autoComplete="off" className="option-form" >
                <div className="account">
                    <h5>Account Info.</h5>
                    <input className="input" type="text" placeholder="Enter Your Name" onChange={(e)=>{setName(e.target.value)}} />
                    <CopyToClipboard text={me}>
                        <button className="button copy" onClick={(e)=>{e.preventDefault()}}>Copy your Id</button>
                    </CopyToClipboard>
                </div>

                <div className="call">
                <h5>Make a call</h5>
                    <input className="input" type="text" placeholder="Id to call" onChange={(e)=>{setIdToCall(e.target.value)}} />
                    {
                        callAccepted && !callEnded ? (
                            <button className="button" onClick={leaveCall}>Hang Up</button>
                        ) : (
                            <button className="button" onClick={(e)=>{
                                e.preventDefault();
                                callUser(idToCall);
                            }}>Make a Call</button>
                        )
                    }
                </div>
            </form>
      </div>
      {/* notifications */}

      {receivingCall && !callAccepted ? (
						<div className="notification">
            <div className="incoming">
                <h3>{name} is Calling!</h3>
                <div className="actions">
                <button onClick={answerCall} className="accept">Accept</button>
                <button className="decline">decline</button>
                </div>
            </div>
            </div>
				) : null}
      </main>
    </div>
  );
}

export default App;
